import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/office/global-search")({
  component: MaskSearchComponent,
});

// Share the mask url
function MaskSearchComponent() {
  return (
    <Navigate
      to="."
      search={() => {
        return {
          action: "global-search",
        };
      }}
      mask={{
        to: "/office/global-search",
      }}
    />
  );
}
